import React from "react";

const IsMobileContext = React.createContext<boolean>(false);

export {IsMobileContext};
